import React from 'react';
import { MapPin, Phone, Clock, Mail, Instagram } from 'lucide-react';
import { companyInfo, phoneDigits } from '../data/mock';

const links = [
  { id: 'home', label: 'Início' },
  { id: 'benches', label: 'Bancadas' },
  { id: 'services', label: 'Serviços' },
  { id: 'how', label: 'Como funciona' },
  { id: 'about', label: 'Sobre' },
  { id: 'reviews', label: 'Avaliações' },
  { id: 'faq', label: 'Perguntas frequentes' },
  { id: 'contact', label: 'Contato' }
];

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#111111] border-t border-[#2a2a2a] py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-nova.png" alt="O.C. GOMES" className="h-14 w-14 rounded-full object-contain" />
              <h3 className="text-xl font-bold text-[#FF6B00] leading-tight">{companyInfo.legalName}</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Injeção eletrônica, mecânica e unidades injetoras, com teste em bancada própria e 90 dias de garantia.
            </p>
            <p className="text-gray-500 text-xs" data-testid="footer-cnpj">CNPJ: {companyInfo.cnpj}</p>
            <div className="flex gap-4 mt-4" data-testid="footer-socials">
              {companyInfo.socials.map((s) => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.label.toLowerCase()}`} className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FF6B00] text-sm transition-colors border border-[#2a2a2a] hover:border-[#FF6B00] rounded-full px-4 py-2">
                  <Instagram size={16} /> {s.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Navegação</h4>
            <ul className="grid grid-cols-2 gap-2">
              {links.map((l) => (
                <li key={l.id}>
                  <button onClick={() => scrollTo(l.id)} className="text-gray-400 hover:text-[#FF6B00] transition-colors text-sm text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contato</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={16} className="text-[#FF6B00] mt-0.5 flex-shrink-0" />
                <a href={companyInfo.mapsUrl} target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B00] transition-colors">{companyInfo.address}</a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone size={16} className="text-[#FF6B00] flex-shrink-0" />
                <a href={`tel:+55${phoneDigits}`} className="hover:text-[#FF6B00] transition-colors">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Clock size={16} className="text-[#FF6B00] flex-shrink-0" />
                {companyInfo.hours}
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail size={16} className="text-[#FF6B00] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-[#FF6B00] transition-colors">{companyInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#2a2a2a] text-center">
          <p className="text-gray-500 text-sm">© {year} {companyInfo.legalName}. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
